import { render, staticRenderFns } from "./TextureWrapper.vue?vue&type=template&id=1a29a064&"
import script from "./TextureWrapper.vue?vue&type=script&lang=js&"
export * from "./TextureWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TextureWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports